import { APP_WILL_MOUNT } from '../../base/app/actionTypes';
import MiddlewareRegistry from '../../base/redux/MiddlewareRegistry';
import { mountChatOverlay } from './mount';
let mounted = false;
function tryMount() {
    if (mounted) {
        return true;
    }
    const realStore = window.APP?.store;
    if (realStore && typeof realStore.subscribe === 'function') {
        console.log('[TBL-Chat] ✅ APP.store disponible, montage du ChatOverlay');
        mounted = true;
        mountChatOverlay(realStore);
        return true;
    }
    return false;
}
MiddlewareRegistry.register(() => next => action => {
    const result = next(action);
    if (action.type === APP_WILL_MOUNT && !mounted) {
        console.log('[TBL-Chat] APP_WILL_MOUNT → tentative de montage');
        if (!tryMount()) {
            // APP.store pas encore prêt — poll toutes les 100ms (max 50 tentatives = 5s)
            let attempts = 0;
            const interval = setInterval(() => {
                attempts++;
                if (tryMount() || attempts > 50) {
                    if (attempts > 50) {
                        console.error('[TBL-Chat] ❌ APP.store introuvable après 5s');
                    }
                    clearInterval(interval);
                }
            }, 100);
        }
    }
    return result;
});
